import moment from "moment";
import Constants from "../util/Constants";
import DashboardDateUtil from "../util/DashboardDateUtil";
import {P} from "oca-lib-web";
import { getGlobal } from 'reactn';
import { Cache } from 'aws-amplify';

export default class GooglePlayDataAccess {

    public data:Array<AppStoreReport> = [];

    public async fetchData(dataSourceId:string, timeInterval:TimeInterval):Promise<any> {
        this.loadCacheIfAvailable();
        if (this.data.length > 0) {
            console.log(this.data);
            return P.resolve(true);
        }

        var self = this;
        return new Promise(async function(resolve, reject) {
            let input:ReportInput = {
                field: "getGooglePlayReport",
                dataSourceId: dataSourceId,
                fromDate: DashboardDateUtil.getPreviousTimeInterval().start,
                toDate: moment(timeInterval.end).subtract(1,'day').format("YYYYMMDD"),
                interval: DashboardDateUtil.getDateInterval(timeInterval.interval)
            };
            //console.log("GooglePlayDataAccess");
            //console.log(input);
            //let googleReport:Array<GooglePlayInstallReport> = await AWS.query(GooglePlayReportQuery.GetGooglePlayReport, {input: input});
            let googleReport:Array<GooglePlayInstallReport> = await getGlobal().dataManager.get("getGooglePlayData", input);
            for (let googleReportItem of googleReport) {
                self.data.push({
                    date: moment(googleReportItem.date, "YYYY-MM-DD").format("YYYYMMDD"),
                    deviceType: Constants.APP_ANDROID,
                    installs: parseInt(googleReportItem.installEvents),
                    sales: 0,
                    uninstalls: parseInt(googleReportItem.uninstallEvents),
                    upgrades: parseInt(googleReportItem.dailyDeviceUpgrades),
                    activeDevices: parseInt(googleReportItem.activeDeviceInstalls),
                });
            }
            console.log(self.data);
            self.cacheData();
            resolve(true);
        });
    }

    public loadCacheIfAvailable() {
        let cacheData = Cache.getItem("GooglePlay");
        if (cacheData) {
            console.log("Loading GooglePlay from cache");
            this.data = cacheData;
        }
    }

    public cacheData() {
        Cache.setItem("GooglePlay", this.data);
    }

    public clearData() {
        this.data = [];
    }

    public clearCache() {
        Cache.removeItem("GooglePlay");
    }
}